// Vendor libraries
import { EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import cloneDeep from 'lodash.clonedeep';
// Constants
import { ASC } from 'NewAngular/constants/core.constants';
import { FOLDERABLE_OPERATION_SLICE_KEY } from 'FoldersApp/state/folderable-operation/folderable-operation.reducer';
import { FOLDERABLE_APP_CONFIG } from 'FoldersApp/constants/folderable-app-config.constants';
import { FolderCollectionViewSortColumn } from 'FoldersApp/enums/folder-views.enums';
import { ToastMessageType } from 'NewAngular/features/components/toast-messages/toast-messages.enum';
// Services
import { BulkActionSelectionService } from 'FoldersApp/services/bulk-action-selection.service';
import { AppStateManager } from 'NewAngular/services/app-state-manager.service';
import { BaseSavedItemService } from 'NewAngular/features/components/saved-items/services/common-services/base-saved-item.service';
import { FolderCollectionService } from 'FoldersApp/services/folder-collection.service';
import { FolderableCollectionServiceBase } from 'FoldersApp/services/folderable-collection-service-base.service';
import { FolderableOperationValue } from 'FoldersApp/state/folderable-operation/folderable-operation-value.enum';
import { FolderOperationsService } from 'FoldersApp/services/folder-operations.service';
import { ItemSelectionService } from 'NewAngular/services/item-selection.service';
import { SelectedFolderableService } from 'FoldersApp/services/selected-folderable.service';
import { ToastMessagesService } from 'NewAngular/features/components/toast-messages/toast-messages.service';
// NgRx
import { setFolderableOperation } from 'FoldersApp/state/folderable-operation/folderable-operation.action';
import { FolderableAppType } from 'FoldersApp/enums/folderable-app-type.enum';
import { FolderExpansionService } from 'FoldersApp/services/folder-expansion-service/folder-expansion.service';
import * as i0 from "@angular/core";
import * as i1 from "FoldersApp/services/folder-collection.service";
import * as i2 from "FoldersApp/services/folderable-collection-service-base.service";
import * as i3 from "@ngrx/store";
import * as i4 from "FoldersApp/services/folder-operations.service";
import * as i5 from "NewAngular/services/item-selection.service";
import * as i6 from "NewAngular/features/components/saved-items/services/common-services/base-saved-item.service";
import * as i7 from "FoldersApp/services/selected-folderable.service";
import * as i8 from "NewAngular/features/components/toast-messages/toast-messages.service";
import * as i9 from "NewAngular/services/app-state-manager.service";
import * as i10 from "@angular/common";
import * as i11 from "../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i12 from "@angular/forms";
import * as i13 from "../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i14 from "../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
import * as i15 from "../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i16 from "../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
import * as i17 from "FoldersApp/features/folders-shared/folderable-column-headers-component/folderable-column-headers.component";
import * as i18 from "FoldersApp/features/folders-shared/folder-breadcrumb/folder-breadcrumb.component";
import * as i19 from "FoldersApp/features/folders-shared/folder-create/folder-create.component";
import * as i20 from "FoldersApp/features/folders-shared/folder-folderable-list-item/folder-folderable-list-item.component";
const _c0 = a0 => ({ "visibility": a0 });
const _c1 = () => ({ visibility: "hidden" });
const _c2 = (a0, a1, a2) => ({ id: a0, name: a1, permissions: a2 });
const _forTrack0 = ($index, $item) => $item.item.id;
function FolderableSaveAsModalComponent_Conditional_2_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 12);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("textContent", ctx_r1.error);
} }
function FolderableSaveAsModalComponent_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "div", 4)(3, "input", 5);
    i0.ɵɵtwoWayListener("ngModelChange", function FolderableSaveAsModalComponent_Conditional_2_Template_input_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.fileName, $event) || (ctx_r1.fileName = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(4, FolderableSaveAsModalComponent_Conditional_2_div_4_Template, 1, 1, "div", 6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 7)(6, "div", 8)(7, "button", 9);
    i0.ɵɵlistener("click", function FolderableSaveAsModalComponent_Conditional_2_Template_button_click_7_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.close()); });
    i0.ɵɵtext(8, "Cancel");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "button", 10);
    i0.ɵɵlistener("click", function FolderableSaveAsModalComponent_Conditional_2_Template_button_click_9_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.toggleViewStyle()); });
    i0.ɵɵtext(10, "Save to Folder");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "button", 11);
    i0.ɵɵlistener("click", function FolderableSaveAsModalComponent_Conditional_2_Template_button_click_11_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.save()); });
    i0.ɵɵtext(12, "Save");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("maxLength", 255);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.fileName);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.error);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("disabled", ctx_r1.fileName === "");
} }
function FolderableSaveAsModalComponent_Conditional_3_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 12);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("textContent", ctx_r1.error);
} }
function FolderableSaveAsModalComponent_Conditional_3_Conditional_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1, "Search Results");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("hidden", !ctx_r1.folderableCollectionService.textSearchActive);
} }
function FolderableSaveAsModalComponent_Conditional_3_Conditional_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-folder-breadcrumb", 16);
} if (rf & 2) {
    i0.ɵɵproperty("displayFlex", false);
} }
function FolderableSaveAsModalComponent_Conditional_3_Conditional_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol", 33);
} if (rf & 2) {
    i0.ɵɵproperty("loaderMessage", "Loading Folders..");
} }
function FolderableSaveAsModalComponent_Conditional_3_Conditional_26_Conditional_0_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵtext(1, " Get Started.");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4, "Create a new Folder");
    i0.ɵɵelementEnd()();
} }
function FolderableSaveAsModalComponent_Conditional_3_Conditional_26_Conditional_0_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtext(1, " No Results.");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementStart(3, "span")(4, "a", 36);
    i0.ɵɵlistener("click", function FolderableSaveAsModalComponent_Conditional_3_Conditional_26_Conditional_0_Conditional_1_Template_a_click_4_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.clearFilters()); });
    i0.ɵɵtext(5, "Clear Filters");
    i0.ɵɵelementEnd()()();
} }
function FolderableSaveAsModalComponent_Conditional_3_Conditional_26_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, FolderableSaveAsModalComponent_Conditional_3_Conditional_26_Conditional_0_Conditional_0_Template, 5, 0, "div", 34)(1, FolderableSaveAsModalComponent_Conditional_3_Conditional_26_Conditional_0_Conditional_1_Template, 6, 0, "div", 35);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵconditional(ctx_r1.folderCollectionService.userHasNoData ? 0 : 1);
} }
function FolderableSaveAsModalComponent_Conditional_3_Conditional_26_Conditional_1_For_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-folder-folderable-list-item", 37);
} if (rf & 2) {
    const folderable_r5 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("folderable", folderable_r5)("ancestorInfo", i0.ɵɵpureFunction3(2, _c2, ctx_r1.folderCollectionService.viewRootFolder.id, ctx_r1.folderCollectionService.viewRootFolder.name, ctx_r1.folderCollectionService.viewRootFolder.permissions));
} }
function FolderableSaveAsModalComponent_Conditional_3_Conditional_26_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, FolderableSaveAsModalComponent_Conditional_3_Conditional_26_Conditional_1_For_1_Template, 1, 6, "ycn-folder-folderable-list-item", 37, _forTrack0);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵrepeater(ctx_r1.folderCollectionService.items);
} }
function FolderableSaveAsModalComponent_Conditional_3_Conditional_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, FolderableSaveAsModalComponent_Conditional_3_Conditional_26_Conditional_0_Template, 2, 1)(1, FolderableSaveAsModalComponent_Conditional_3_Conditional_26_Conditional_1_Template, 2, 0);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r1.folderCollectionService.items.length === 0 ? 0 : 1);
} }
function FolderableSaveAsModalComponent_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "div", 4)(3, "input", 13);
    i0.ɵɵtwoWayListener("ngModelChange", function FolderableSaveAsModalComponent_Conditional_3_Template_input_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.fileName, $event) || (ctx_r1.fileName = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, FolderableSaveAsModalComponent_Conditional_3_div_4_Template, 1, 1, "div", 6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 3)(6, "div", 14);
    i0.ɵɵtemplate(7, FolderableSaveAsModalComponent_Conditional_3_Conditional_7_Template, 2, 1, "div", 15)(8, FolderableSaveAsModalComponent_Conditional_3_Conditional_8_Template, 1, 1, "ycn-folder-breadcrumb", 16);
    i0.ɵɵelementStart(9, "div", 17)(10, "div", 18)(11, "input", 19);
    i0.ɵɵtwoWayListener("ngModelChange", function FolderableSaveAsModalComponent_Conditional_3_Template_input_ngModelChange_11_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.searchTerm, $event) || (ctx_r1.searchTerm = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("keydown.enter", function FolderableSaveAsModalComponent_Conditional_3_Template_input_keydown_enter_11_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.setSearchTerm()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 20)(13, "button", 21);
    i0.ɵɵlistener("click", function FolderableSaveAsModalComponent_Conditional_3_Template_button_click_13_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.setSearchTerm()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(14, "svg", 22);
    i0.ɵɵelementEnd()()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(15, "ycn-folder-create", 23);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(16, "div", 24);
    i0.ɵɵelement(17, "div", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 26)(19, "div", 27);
    i0.ɵɵlistener("setSort", function FolderableSaveAsModalComponent_Conditional_3_Template_div_setSort_19_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.setSort($event)); });
    i0.ɵɵelementStart(20, "div", 28)(21, "label", 29);
    i0.ɵɵelement(22, "input", 30)(23, "span", 31);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(24, "div", 32);
    i0.ɵɵtemplate(25, FolderableSaveAsModalComponent_Conditional_3_Conditional_25_Template, 1, 1, "ycn-loading-symbol", 33)(26, FolderableSaveAsModalComponent_Conditional_3_Conditional_26_Template, 2, 1);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(27, "div", 7)(28, "div", 8)(29, "button", 9);
    i0.ɵɵlistener("click", function FolderableSaveAsModalComponent_Conditional_3_Template_button_click_29_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.close()); });
    i0.ɵɵtext(30, "Cancel");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(31, "button", 10);
    i0.ɵɵlistener("click", function FolderableSaveAsModalComponent_Conditional_3_Template_button_click_31_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.toggleViewStyle()); });
    i0.ɵɵtext(32, "Back");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(33, "button", 11);
    i0.ɵɵlistener("click", function FolderableSaveAsModalComponent_Conditional_3_Template_button_click_33_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.save()); });
    i0.ɵɵtext(34, "Submit");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.fileName);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.error);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.folderableCollectionService.textSearchActive ? 7 : 8);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("maxLength", 255);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.searchTerm);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("name", "icon-search");
    i0.ɵɵadvance();
    i0.ɵɵproperty("visibleFlex", false);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(15, _c0, ctx_r1.folderableCollectionService.loading ? "visible" : "hidden"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("columnConfig", ctx_r1.FOLDER_COLUMN_CONFIG)("sortableColumns", ctx_r1.sortableColumns)("sortColumn", ctx_r1.folderCollectionService.dataParams.sortColumn)("sortDirection", ctx_r1.folderCollectionService.dataParams.sortDirection);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction0(17, _c1));
    i0.ɵɵadvance(4);
    i0.ɵɵconditional(ctx_r1.folderCollectionService.showLoading && ctx_r1.folderCollectionService.loading ? 25 : ctx_r1.folderCollectionService.viewRootFolder ? 26 : -1);
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("disabled", ctx_r1.fileName === "");
} }
var FolderableSaveAsModalViewStyle;
(function (FolderableSaveAsModalViewStyle) {
    FolderableSaveAsModalViewStyle["SAVE_AS"] = "saveAs";
    FolderableSaveAsModalViewStyle["SAVE_TO_FOLDER"] = "saveToFolder";
})(FolderableSaveAsModalViewStyle || (FolderableSaveAsModalViewStyle = {}));
const saveAsFolderableAppConfig = {
    folderableAppType: FolderableAppType.MODAL,
    itemNamePlural: 'Folders',
};
export class FolderableSaveAsModalComponent {
    constructor(folderCollectionService, folderableCollectionService, store, folderOperationsService, itemSelectionService, savedItemService, selectedFolderableService, toastMessagesService, appStateManagerService) {
        this.folderCollectionService = folderCollectionService;
        this.folderableCollectionService = folderableCollectionService;
        this.store = store;
        this.folderOperationsService = folderOperationsService;
        this.itemSelectionService = itemSelectionService;
        this.savedItemService = savedItemService;
        this.selectedFolderableService = selectedFolderableService;
        this.toastMessagesService = toastMessagesService;
        this.appStateManagerService = appStateManagerService;
        this.customSaveErrorHandler = new EventEmitter();
        this.sortableColumns = FolderCollectionViewSortColumn;
        this.FOLDER_COLUMN_CONFIG = {
            [FolderCollectionViewSortColumn.NAME]: {
                label: 'name',
                numCssCols: 3,
                defaultSortDirection: ASC,
            },
            [FolderCollectionViewSortColumn.MODIFY_DATE]: {
                label: 'date modified',
                numCssCols: 3,
                defaultSortDirection: ASC,
            },
            [FolderCollectionViewSortColumn.OWNER_NAME]: {
                label: 'owner',
                numCssCols: 2,
                defaultSortDirection: ASC,
            },
        };
        this.FolderableSaveAsModalViewStyle = FolderableSaveAsModalViewStyle;
        this.state = null;
        this.isOpen = false;
        this.viewStyle = FolderableSaveAsModalViewStyle.SAVE_AS;
        this.fileName = '';
        this.error = '';
        this.searchTerm = '';
    }
    ngOnInit() {
        this.store.select('reducers').subscribe((_rootStore) => {
            const state = _rootStore[_rootStore.appStateSliceKey];
            this.state = this.appStateManagerService.deserialize(state);
        });
        this.folderableCollectionSubscription = this.folderableCollectionService.viewResponse$.subscribe((response) => {
            if (response === null)
                return;
            const viewRootFolder = { ...response.viewRootFolder };
            this.itemSelectionService.clearSelections();
            this.itemSelectionService.selectItem(viewRootFolder);
            this.searchTerm = response.params.name;
        });
    }
    ngAfterViewInit() {
        this.selectedOperationSubscription = this.store
            .select(FOLDERABLE_OPERATION_SLICE_KEY)
            .subscribe((operation) => {
            if (operation !== FolderableOperationValue.SAVE_AS)
                return;
            this.isOpen = true;
            this.folderCollectionService.refreshData();
            const selectedItem = this.selectedFolderableService.getSelection();
            if (selectedItem !== null) {
                this.fileName = `${selectedItem.item.name} - DUPLICATE`;
            }
        });
    }
    ngOnDestroy() {
        this.selectedOperationSubscription.unsubscribe();
        this.folderableCollectionSubscription.unsubscribe();
    }
    close() {
        this.isOpen = false;
        this.store.dispatch(setFolderableOperation({ operation: null }));
        this.resetModal();
    }
    resetModal() {
        this.fileName = '';
        this.error = '';
        this.viewStyle = FolderableSaveAsModalViewStyle.SAVE_AS;
        this.itemSelectionService.clearSelections();
    }
    resetError() {
        this.error = '';
    }
    toggleViewStyle() {
        switch (this.viewStyle) {
            case FolderableSaveAsModalViewStyle.SAVE_TO_FOLDER:
                this.viewStyle = FolderableSaveAsModalViewStyle.SAVE_AS;
                this.itemSelectionService.clearSelections();
                break;
            case FolderableSaveAsModalViewStyle.SAVE_AS:
                this.viewStyle = FolderableSaveAsModalViewStyle.SAVE_TO_FOLDER;
                break;
            default:
        }
        this.resetError();
    }
    setSort(sort) {
        const params = {
            ...cloneDeep(this.folderCollectionService.dataParams),
            sortColumn: sort.sortColumn,
            sortDirection: sort.sortDirection,
        };
        this.folderCollectionService.refreshData(params);
    }
    clearFilters() {
        const params = {
            ...cloneDeep(this.folderCollectionService.dataParams),
            // The name filter is only used in the saveAs view
            name: '',
        };
        this.folderCollectionService.refreshData(params);
    }
    setSearchTerm() {
        if (this.searchTerm === this.folderCollectionService.dataParams.name)
            return;
        const params = cloneDeep(this.folderCollectionService.dataParams);
        params.name = this.searchTerm;
        this.folderCollectionService.refreshData(params);
    }
    save() {
        this.fileName = this.fileName.trim();
        if (this.fileName === '') {
            this.error = 'Please enter a non-empty value';
            return;
        }
        this.resetError();
        const params = { ...this.state };
        this.savedItemService.createItem(params, this.fileName).subscribe({
            next: (response) => {
                const targetFolder = this.itemSelectionService.selectedItem;
                this.selectedFolderableService.selectFolderable(response.id);
                const { id, resourceType } = response;
                if (targetFolder && targetFolder.id !== null) {
                    // If the item was supposed to be saved to a selected folder,
                    // attempt to move the newly created item into the selected folder.
                    this.moveFolderableItem(resourceType, id, targetFolder);
                }
                else {
                    this.toastMessagesService.addMessage(`Created "${this.fileName}"`);
                    this.close();
                }
            },
            error: (response) => {
                if (this.customSaveErrorHandler.observed) {
                    this.customSaveErrorHandler.emit(response);
                }
                else {
                    let message = `There was an error creating "${this.fileName}"`;
                    if (Object.keys(response.error).includes('error_message')) {
                        message = response.error.error_message;
                    }
                    this.toastMessagesService.addMessage(message, ToastMessageType.ERROR);
                }
            },
        });
    }
    moveFolderableItem(resourceType, itemId, targetFolder) {
        this.folderOperationsService.moveFolderableItem(resourceType, itemId, targetFolder.id).subscribe({
            next: () => {
                this.toastMessagesService.addMessage(`Created "${this.fileName}" in folder "${targetFolder.name}".`);
                this.close();
            },
            error: () => {
                this.toastMessagesService.addMessage(`Created "${this.fileName}". However, there was an error moving "${this.fileName}" to the selected folder.`, ToastMessageType.ERROR);
            },
        });
    }
}
FolderableSaveAsModalComponent.ɵfac = function FolderableSaveAsModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FolderableSaveAsModalComponent)(i0.ɵɵdirectiveInject(i1.FolderCollectionService), i0.ɵɵdirectiveInject(i2.FolderableCollectionServiceBase), i0.ɵɵdirectiveInject(i3.Store), i0.ɵɵdirectiveInject(i4.FolderOperationsService), i0.ɵɵdirectiveInject(i5.ItemSelectionService), i0.ɵɵdirectiveInject(i6.BaseSavedItemService), i0.ɵɵdirectiveInject(i7.SelectedFolderableService), i0.ɵɵdirectiveInject(i8.ToastMessagesService), i0.ɵɵdirectiveInject(i9.AppStateManager)); };
FolderableSaveAsModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FolderableSaveAsModalComponent, selectors: [["ycn-folderable-save-as-modal"]], inputs: { modalHeader: "modalHeader" }, outputs: { customSaveErrorHandler: "customSaveErrorHandler" }, standalone: false, features: [i0.ɵɵProvidersFeature([
            BulkActionSelectionService,
            FolderCollectionService,
            FolderExpansionService,
            ItemSelectionService,
            { provide: FolderableCollectionServiceBase, useExisting: FolderCollectionService },
            { provide: FOLDERABLE_APP_CONFIG, useValue: saveAsFolderableAppConfig },
        ])], decls: 4, vars: 6, consts: [[3, "closeModalHandler", "modalBaseClass", "extraModalClasses", "open"], [3, "closeModalHandler", "header", "showUnsavedStatus"], [1, "modal-body"], [1, "modal-section"], [1, "form-row", "pb-1"], ["placeholder", "Enter a name", 1, "form-control", 3, "ngModelChange", "maxLength", "ngModel"], ["class", "feedback feedback-invalid", 3, "textContent", 4, "ngIf"], [1, "modal-footer"], [1, "modal-footer-actions"], ["type", "button", "data-dismiss", "modal", 1, "btn", "btn-text", 3, "click"], ["type", "button", 1, "btn", "btn-ghost", "btn-outline", 3, "click"], ["type", "button", "ycnDisabled", "", 1, "btn", "btn-primary", 3, "click", "disabled"], [1, "feedback", "feedback-invalid", 3, "textContent"], ["placeholder", "Enter a name", 1, "form-control", 3, "ngModelChange", "ngModel"], [1, "modal-section-header", "border-t", "border-color-gray-90"], [1, "file-path", "text-bold", 3, "hidden"], [3, "displayFlex"], [1, "form-inline"], [1, "field-input-group", "field-search", "input-group"], ["placeholder", "Search Folder", 1, "form-control", "field-input", 3, "ngModelChange", "keydown.enter", "maxLength", "ngModel"], [1, "field-input-group-actions"], [1, "btn", "btn-transparent", 3, "click"], ["role", "img", "ycnIcon", "", 1, "icon-search", 3, "name"], [3, "visibleFlex"], [1, "bg-yc-blue-75", 3, "ngStyle"], [1, "page-progress-bar"], [1, "table", "table-hover", "file-table", "overflow-auto"], ["ycn-folderable-column-headers", "", 1, "thead", 3, "setSort", "columnConfig", "sortableColumns", "sortColumn", "sortDirection"], [1, "file-td-control", "td"], [1, "custom-control", "custom-checkbox", "custom-checkbox-style1", "checkbox-single", "d-flex", 3, "ngStyle"], ["type", "checkbox", "checked", "true", "name", "securities-list", 1, "custom-control-input"], [1, "custom-control-indicator"], [1, "tbody"], ["data-test-id", "save-as-folders-loading-symbol", 3, "loaderMessage"], [1, "get-started", "flex-auto"], [1, "get-started", "flex-auto", "min-height-220"], ["href", "javascript:void(0)", 1, "text-blue", 3, "click"], [3, "folderable", "ancestorInfo"]], template: function FolderableSaveAsModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 0);
        i0.ɵɵlistener("closeModalHandler", function FolderableSaveAsModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.close(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 1);
        i0.ɵɵlistener("closeModalHandler", function FolderableSaveAsModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.close(); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(2, FolderableSaveAsModalComponent_Conditional_2_Template, 13, 4)(3, FolderableSaveAsModalComponent_Conditional_3_Template, 35, 18);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("modalBaseClass", "modal-fix-scroll")("extraModalClasses", "modal-no-border user-select-none")("open", ctx.isOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", ctx.modalHeader)("showUnsavedStatus", false);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.viewStyle === ctx.FolderableSaveAsModalViewStyle.SAVE_AS ? 2 : 3);
    } }, dependencies: [i10.NgIf, i10.NgStyle, i11.IconDirective, i12.DefaultValueAccessor, i12.NgControlStatus, i12.NgModel, i13.DisabledDirective, i14.LoadingSymbolComponent, i15.ModalBaseComponent, i16.SimpleModalHeaderComponent, i17.FolderableColumnHeadersComponent, i18.FolderBreadcrumbComponent, i19.FolderCreateComponent, i20.FolderFolderableListItemComponent], encapsulation: 2 });
